import {useAppSelector} from 'store/hooks';
import {selectMetadataEditSaving} from '../metadataEditSlice';

export const useMetadataSaveState = () => {
  return useAppSelector(selectMetadataEditSaving);
};
